<ion-header>
  <div
    class="appbar"
    [class.isLandscape]="isLandscape()"
    [class.isPortrait]="!isLandscape()"
  >
    <div class="logo" [routerLink]="['/home']" router-direction="back"></div>

    <div class="heading-wrapper">
      <!-- <div class="menu-button logout" (click)="logout()">
        <span class="material-symbols-outlined"> move_item </span>
      </div> -->
      <div class="appbar-lang">
        <app-language-component></app-language-component>
      </div>
      <div
        class="user-picture"
        [style.background-image]="'url(' + user()?.avatar + ')'"
        [routerLink]="['/profile']"
      ></div>

      <div class="menu-button chat">
        <span
          class="material-symbols-outlined"
          (click)="!user()?.enableTwixor ? showMaintananceMsg() : null"
          [routerLink]="['/chat']"
        >
          forum
        </span>
      </div>

      <div class="menu-button chat" (click)="openMenu()">
        <span class="material-symbols-outlined"> menu </span>
      </div>
    </div>
  </div>
</ion-header>

<ion-router-outlet id="main-content"></ion-router-outlet>
